import {useSlotProps as $7OPyf$useSlotProps, useStyleProps as $7OPyf$useStyleProps, useDOMRef as $7OPyf$useDOMRef, ClearSlots as $7OPyf$ClearSlots} from "@react-spectrum/utils";
import {filterDOMProps as $7OPyf$filterDOMProps} from "@react-aria/utils";
import $7OPyf$react, {forwardRef as $7OPyf$forwardRef} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $0a7c18a2ef74b280$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $7OPyf$forwardRef)(function Content(props, ref) {
    props = (0, $7OPyf$useSlotProps)(props, 'content');
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $7OPyf$useStyleProps)(otherProps);
    let domRef = (0, $7OPyf$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $7OPyf$react).createElement("section", {
        ...(0, $7OPyf$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, $7OPyf$react).createElement((0, $7OPyf$ClearSlots), null, children));
});


export {$0a7c18a2ef74b280$export$7c6e2c02157bb7d2 as Content};
//# sourceMappingURL=Content.module.js.map
